import { FiCheck } from "react-icons/fi";
import "./feature-detail-card.scss";

type FeatureDetailCardProps = {
  title: string;
  items?: string[];
  texts?: string[];
  buttonText: string;
};

export const FeatureDetailCard = (props: FeatureDetailCardProps) => {
  const { title, items, texts, buttonText } = props;

  return (
    <div className="feature-detail-card">
      <h2>{title}</h2>

      {texts?.length ? (
        <div className="feature-detail-card-texts">
          {texts.map((text) => (
            <p key={text}>{text}</p>
          ))}
        </div>
      ) : (
        <ul>
          {(items || []).map((item) => (
            <li key={item}>
              <FiCheck
                className="feature-detail-card-check"
                aria-hidden="true"
              />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      )}

      <button type="button">{buttonText}</button>
    </div>
  );
};
